// google maps implementation

function initMap() {
    map = new google.maps.Map(document.getElementById('leaflet-map'), {
        center: new google.maps.LatLng(0, 0),
        zoom: 2.5,
        styles: mapStyle,
        scrollwheel: false,
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false,
        minZoom: 2.5,
        zoomControl: true,
        zoomControlOptions: {
            style: google.maps.ZoomControlStyle.SMALL
        }
    });
    
    map.addListener('dragstart', function() {
        $('.marker-parent').removeClass('active');
    });

    if($(window).width() > 768) {
        scrollbar.addListener(function(s) {
            $('.marker-parent').removeClass('active');
        });
    } else {
        $(window).scroll(function () { 
            $('.marker-parent').removeClass('active');
        });
    }

    for (var i = 0; i < locations.length; i++) {
        var item = locations[i];
        var slug = item[1];
        var html = markerHTML(slug, item[0], item[4], item[6]);
        let marker = createHTMLMapMarker({
            latlng: new google.maps.LatLng(item[2], item[3]),
            map: map,
            html: html,
            slug: slug
        });

        marker.addListener("click", function(e) {
            $('.marker-parent').removeClass('active');
            $('.pin-marker.marker-' + marker.slug).parent('.marker-parent').addClass('active');
            // map.setZoom(8);
            map.setCenter(marker.getPosition());
            map.panBy(0,-100);
            // console.log(marker.slug);
            // event push
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'work.map.click',
            });
        });

        markers.push(marker);
    }

    function markerHTML(slug, label, image, copyright) {
        var markerhtml = 
            '<div class="pin-marker marker-'+ slug +'">'+
                '<div class="info">' +
                    '<div class="img" style="background-image:url('+ window.location.protocol + "//" + window.location.host + image +');"><div class="credit">' + copyright + '</div></div>' +
                    '<div class="text">' + label + '</div>' +
                '</div>'+
            '</div>' ;
        
        return markerhtml;
    }

    function centeredMap() {

		var bounds = new google.maps.LatLngBounds();
		for(i=0;i<markers.length;i++) {
		   bounds.extend(markers[i].getPosition());
		//    console.log(markers[i].getPosition());
		}

		//center the map to a specific spot (city)
		map.setCenter(new google.maps.LatLng(0, 0)); 

		//center the map to the geometric center of all markers
		map.setCenter(bounds.getCenter());

		map.fitBounds(bounds);

		//remove one zoom level to ensure no marker is on the edge.
		// map.setZoom(map.getZoom()); 
		// console.log(map.getZoom());
		// set a minimum zoom 
        // if you got only 1 marker or all markers are on the same address map will be zoomed too much.
        
        // console.log(map.getZoom());
		if(map.getZoom() > 15){
            map.setZoom(5);
            // console.log('teest');
		}else{
            // console.log(map.getZoom());
			map.setZoom(map.getZoom()); 
		}
        // console.log(map.getZoom());
		//Alternatively this code can be used to set the zoom for just 1 marker and to skip redrawing.
		//Note that this will not cover the case if you have 2 markers on the same address.
		if(markers.length == 1){
		    // map.setMaxZoom(15);
		    // map.fitBounds(bounds);
		    // map.setMaxZoom(Null)
		}

		// map.fitBounds(bounds);
    }

    centeredMap();
}

$(document).ready(function () {
    setTimeout(function() {
        initMap();
    }, 3000);
});